export default "__VITE_ASSET__BAzB7p2l__"